import React from 'react';
import classnames from 'classnames';
import style from './Text.scss';

const comparator = (compareTo) => (val) => val === compareTo;

export enum SIZES {
  tiny = 'tiny',
  small = 'small',
  medium = 'medium',
}

export enum WEIGHTS {
  thin = 'thin',
  normal = 'normal',
  bold = 'bold',
}

interface TextProps {
  dataHook?: string;
  tagName?: string;
  className?: string;
  size?: SIZES;
  children?: any;
  inline?: boolean;
  menuLink?: boolean;
  secondary?: boolean;
  light?: boolean;
  weight?: WEIGHTS;
  link?: boolean;
  ellipsis?: boolean;
}

export const Text = React.memo<TextProps | any>(
  ({
    size = SIZES.medium,
    secondary = false,
    light = false,
    weight = WEIGHTS.thin,
    inline = false,
    children,
    tagName = 'p',
    className = '',
    link = false,
    menuLink = false,
    ellipsis = false,
    ...rest
  }) => {
    const getClassNames = () =>
      classnames({
        [style.text]: true,
        [style.tiny]: comparator(SIZES.tiny)(size),
        [style.small]: comparator(SIZES.small)(size),
        [style.medium]: comparator(SIZES.medium)(size),
        [style.thin]: comparator(WEIGHTS.thin)(weight),
        [style.normal]: comparator(WEIGHTS.normal)(weight),
        [style.bold]: comparator(WEIGHTS.bold)(weight),
        [style.secondary]: secondary,
        [style.light]: light,
        [style.link]: link,
        [style.ellipsis]: ellipsis,
        [style.inline]: inline,
        [style.menuLink]: menuLink,
      });
    const { dataHook, ...textProps } = rest;

    return React.createElement(
      tagName,
      {
        ...textProps,
        'data-hook': dataHook,
        className: `${getClassNames()} ${className}`,
      },
      children,
    );
  },
);
